import { logger } from "../../utils/logger";

function XPayPaymentHandler(providerDetails) {
  const paymentLink = providerDetails?.payment_link;

  if (!paymentLink) {
    logger("XPay payment link is missing in the punch payment response");
    return;
  }

  window.location.assign(paymentLink);
}

export { XPayPaymentHandler };
